/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorUnary extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorUnary");
    }

    getFixupPrototypeFunction() { return QueryOperatorUnary.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorUnary>): QueryOperatorUnary {
        let obj = Object.assign(new QueryOperatorUnary(), model);
        QueryOperatorUnary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorUnary>): QueryOperatorUnary {
        if (!model) return null;
        return QueryOperatorUnary.newInstance(<QueryOperatorUnary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorUnary) {
        if (!obj) return;

        models.QueryOperatorUnary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorUnary): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorUnary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.a) {
            models.QueryOperator.fixupPrototype(this.a);
        }
    }

    /**
     * Sub-expression of the unary query operator
     */
    a: models.QueryOperator;

}
